export const PROJECT_NAME = 'Gibi Delivery';
export const BASE_URL = 'https://api.gibistrot.it';
export const api_url = BASE_URL + '/api/v1/';
export const api_url_admin_dashboard = BASE_URL + '/api/v1/dashboard/';
export const IMG_URL = '';
export const MAP_API_KEY = 'AIzaSyDD1xEmuKoLu-i-a4bEoxswnWcU4UyKVag';
export const export_url = BASE_URL + '/storage/';
export const example = BASE_URL + '/';
export const defaultCenter = { lat: 40.7127281, lng: -74.0060152 };

export const VAPID_KEY =
  'BCraVFXofGmB7xhxQ0m2iHwhhGcn4onwRH9NuoedA_j8aIg1-IjaIn2DiFWV6Y09yEYmzRUWHOQ70NeEBkEIeKw';
export const API_KEY = 'AIzaSyBKBoApByui6kaDsyLRKpFYnn6lU6tqHng';
export const AUTH_DOMAIN = 'gibidelivery-53230.firebaseapp.com';
export const PROJECT_ID = 'gibidelivery-53230';
export const STORAGE_BUCKET = 'gibidelivery-53230.firebasestorage.app';
export const MESSAGING_SENDER_ID = '547051051160';
export const APP_ID = '1:547051051160:web:77d9f7c951bf83947698ed';
export const MEASUREMENT_ID = 'G-BFG2YSDXL8';

export const RECAPTCHASITEKEY = '6LdGKvwrAAAAAGf_2Fy3qgSaPzcFRaE-dpGsLzPO';

export const DEMO_SELLER = 107; // seller_id
export const DEMO_SHOP = 501; // seller_id
export const DEMO_DELIVERYMAN = 106; // deliveryman_id
export const DEMO_MANEGER = 114; // maneger_id
export const DEMO_MODERATOR = 297; // moderator_id
export const DEMO_ADMIN = 501; // administrator_id

export const SUPPORTED_FORMATS = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/svg+xml',
  'image/svg',
];
